/**
 * Convert the tailored-resume JSON (as returned by /api/analyses/<id>) into a
 * plain text resume that the Studio can load as its `content_md`. The Studio
 * editor treats this content as Markdown-ish; we use simple uppercase section
 * headers + bullet rows, mirroring what `composeResumeText()` in ResumeBuilder
 * already produces.
 */
export function tailoredToResumeText(tailored) {
  if (!tailored) return "";
  const lines = [];

  if (tailored.headline) {
    lines.push(tailored.headline);
    lines.push("");
  }

  if (tailored.summary) {
    lines.push("SUMMARY");
    lines.push(tailored.summary.trim());
    lines.push("");
  }

  if ((tailored.key_skills || []).length) {
    lines.push("KEY SKILLS");
    lines.push(tailored.key_skills.join(" · "));
    lines.push("");
  }

  if ((tailored.experience || []).length) {
    lines.push("EXPERIENCE");
    tailored.experience.forEach((exp) => {
      const head = [
        [exp.title, exp.company].filter(Boolean).join(" — "),
        exp.dates ? exp.dates : "",
      ]
        .filter(Boolean)
        .join("  |  ");
      if (head) lines.push(head);
      (exp.bullets || []).forEach((b) => {
        const t = (b || "").trim();
        if (t) lines.push(`• ${t}`);
      });
      lines.push("");
    });
  }

  if ((tailored.education || []).length) {
    lines.push("EDUCATION");
    tailored.education.forEach((ed) => {
      const head = [
        [ed.degree, ed.school].filter(Boolean).join(" — "),
        ed.dates ? ed.dates : "",
      ]
        .filter(Boolean)
        .join("  |  ");
      if (head) lines.push(head);
    });
    lines.push("");
  }

  if ((tailored.additional || []).length) {
    lines.push("ADDITIONAL");
    tailored.additional.forEach((a) => {
      const t = (a || "").trim();
      if (t) lines.push(`• ${t}`);
    });
    lines.push("");
  }

  return lines.join("\n").trim() + "\n";
}
